import { PRODUCT } from "@/constants";

const defaultValues = {
  avanti: {
    acoHeaderClassName: "avn-header font-header-font font-[700]",
  },
  staysure: {
    acoHeaderClassName: "sts-header font-body-font font-[600]",
  },
};

const brand: "staysure" | "avanti" =
  (PRODUCT as "staysure" | "avanti") ?? "staysure";

const singleAcoClassNames = defaultValues[brand];

export default singleAcoClassNames;
